import type { FeatureIconsProps } from '@/pages/solutions/[type]/new-items/feature-icons'
import type { ImageTextItemProps } from '@/pages/solutions/[type]/new-items/image-text'

import banner from '@/assets/img/solution/renewable-energy/banner.jpg'
import imageText_1 from '@/assets/img/solution/renewable-energy/image_text_1.png'
import imageText_2 from '@/assets/img/solution/renewable-energy/image_text_2.jpg'
import imageText_3 from '@/assets/img/solution/renewable-energy/image_text_3.jpg'
import application_1 from '@/assets/img/solution/renewable-energy/application_1.jpg'
import application_2 from '@/assets/img/solution/renewable-energy/application_2.jpg'
import application_3 from '@/assets/img/solution/renewable-energy/application_3.jpg'
import application_4 from '@/assets/img/solution/renewable-energy/application_4.jpg'

export interface SolutionRenewableEnergyProps {
  id: number
  title: string
  description: string
  path: string
  banner: string
  featureIcons?: FeatureIconsProps[]
  imageText?: ImageTextItemProps[]
  advantages?: {
    title: string
    image: string
    items: { title: string; descriptions: string[]; image?: string }[]
  }
  applications?: {
    title: string
    description?: string | string[]
    image: string
  }[]
}

export const solution_renewable_energy: SolutionRenewableEnergyProps = {
  id: 3,
  path: '/solution/renewable-energy',
  banner: banner,
  title: 'Residential Renewable Energy Solution',
  description:
    'Carus Energy delivers turnkey PV and BESS solutions for residential, commercial, and utility-scale projects, leveraging idle land to reduce carbon emissions, enhance grid stability, and lower energy costs with scalable systems.',
  imageText: [
    {
      title: 'Residential Solution – inverter + Ess',
      content: [
        {
          image: imageText_1,
          imageWidth: '56%',
        },
      ],
    },
    {
      flag: 'Solution',
      content: [
        {
          image: imageText_2,
          title: 'new Solar roof tile series',
          cards: [
            {
              title: 'Safety and Reliable',
              description: 'Significantly reduces electricity costs over the long term.',
            },
            {
              title: 'Green energy',
              description: 'High conversion efficiencyProvide sustainable energy',
            },
            {
              title: 'Low cost, High effective',
              description: 'Reduce building costs Solar can be widely used',
            },
            {
              title: 'Waterproof design',
              description: 'Sealing strip at the overlap Double waterproof :Concealed water channel+ rubber strip',
            },
            {
              title: 'Special Design',
              description: 'Similar to natural clay tiles  Have antique looking,good for roof renovation',
            },
            {
              title: 'Easy installation',
              description: 'Standard installation modeMatched traditional clay roofing',
            },
          ],
          descriptions: [
            'Independently developed solar roof tiles and solar exterior panels, high transparency color coating technology endows Solar roof tiles with variety of colors, increasing the aesthetics and diversity of buildings. Currently oﬀered colors: Slate gray speciﬁcally developed for nature slate, clay red suitable for traditional clay rooﬁng, and rock blue imitat- ing metal roofs... with multiple color and texture choices to increase the adaptability of the roof.',
          ],
        },
        {
          image: imageText_3,
          title: 'Residential solution',
          subTitle: 'Powers lighting, appliances, air conditioning, heating systems, and more.',
          descriptions: [
            'Delivers stackable, modular battery units with hybrid inverters for seamless home energy management.',
            'Advanced liquid cooling and multi-level safety protection.',
            'Maximizes solar consumption, provides backup power, and adapts to changing household energy demands.',
            'Empowers homeowners to achieve energy independence and maintain energy security',
          ],
        },
      ],
    },
    {
      title: 'Advantages',
      featureIcons: [
        {
          icon: 'increase',
          label: 'Cost-Effectiveness',
          description: 'Significantly reduces electricity costs over the long term.',
        },
        {
          icon: 'energyIndependence',
          label: 'Energy Independence',
          description: ' Enhances energy security and reliability with backup power capabilities.',
        },
        {
          icon: 'greenEnergy',
          label: 'Environmental Friendliness',
          description: 'Promotes the use of renewable energy and supports corporate sustainability goals.',
        },
        {
          icon: 'energyManage',
          label: 'Smart Energy Management',
          description: 'Optimizes energy usage through advanced monitoring and control systems.',
        },
      ],
    },
  ],
  applications: [
    {
      title: 'Daily Household Electricity Use',
      description: 'Powers lighting, appliances, air conditioning, heating systems, and more.',
      image: application_1,
    },
    {
      title: 'Remote or Off-Grid Areas',
      description: 'Provides stable electricity to areas without grid coverage.',
      image: application_2,
    },
    {
      title: 'Emergency Backup Power',
      description: 'Offers emergency power support during natural disasters or grid failures.',
      image: application_3,
    },
    {
      title: 'Electric Vehicle Charging',
      description: 'Supplies clean energy for charging household electric vehicles.',
      image: application_4,
    },
  ],
}
